import React from "react";
import { Field } from 'react-final-form';
import { InputAdornment, IconButton } from "@mui/material";
import { VisibilityOff, Visibility } from '@mui/icons-material';
import RFTextField from "../form/RFTextField";

export default function PasswordRFTextField({ disabled, autoComplete, label, dirty, name }) {
  const inputRef = React.useRef(null);

  const [passwordType, setPasswordType] = React.useState('password');

  const handleClickShowPassword = React.useCallback(() => {
    setPasswordType(currentPasswordType => currentPasswordType === 'text' ? 'password' : 'text')
  }, []);

  React.useEffect(() => {
    // Moving cursor to the end
    if (dirty) {
      inputRef.current.selectionStart = inputRef.current.value.length;
      inputRef.current.selectionEnd = inputRef.current.value.length;
      inputRef.current.focus();
    }
    // TODO: try to rewrite
    // this is needed because adding dirty to dep array will break autoFocus built into react-final-form components
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [passwordType]);

  return (
    <Field
      inputRef={inputRef}
      label={label}
      fullWidth
      size="large"
      disabled={disabled}
      required
      margin="normal"
      variant="outlined"
      autoComplete={autoComplete}
      name={name}
      component={RFTextField}
      type={passwordType}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              tabIndex={-1}
            >
              {passwordType === 'text' ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        )
      }}
    />
  )
}
  